import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import DiscoveryContentSort from '../sort/DiscoveryContentSort';

import { __t, applyTranslations } from 'utils/language';
import { abbrNum } from 'utils/helper/common';

import './discovery-content-interaction.scss';

type Props = {
  numCreators: number,
  numPosts: number,
  sort: string,
  isFullScreen: boolean,
  onSort: (a: string) => void,
  onToggleFilters: () => void
};

applyTranslations(require('./discovery-content-interaction.i18n.json'));

const msgKey = 'discovery_content_interaction';

class DiscoveryContentInteraction extends React.PureComponent<Props> {
  renderToggle(): React.ReactNode | undefined | null {
    const { isFullScreen, onToggleFilters } = this.props;

    if (!isFullScreen) {
      return null;
    }

    return (
      <div
        className="discovery-content-interaction__toggle"
        onClick={onToggleFilters}
      >
        <div className="discovery-content-interaction__toggle-icon">
          <SVGDynamicIcon
            name="chevron-right-custom-fg"
            width={16}
            height={14}
            customColor="black"
          />
        </div>
        <div className="discovery-content-interaction__toggle-text">
          {__t(`${msgKey}.labels.show_filters`)}
        </div>
      </div>
    );
  }

  renderStat(key: 'num_posts' | 'creators', value: number): React.ReactNode {
    return (
      <div className="discovery-content-interaction__stats-section">
        <div className="discovery-content-interaction__stats-label">
          {__t(`${msgKey}.labels.${key}`)}:
        </div>
        <div className="discovery-content-interaction__stats-value">
          {abbrNum(value)}
        </div>
      </div>
    );
  }

  renderStats(): React.ReactNode {
    const { numCreators, numPosts } = this.props;

    return (
      <div className="discovery-content-interaction__stats">
        {this.renderStat('num_posts', numPosts)}
        {this.renderStat('creators', numCreators)}
      </div>
    );
  }

  renderSort(): React.ReactNode {
    const { sort, onSort } = this.props;

    return (
      <div className="discovery-content-interaction__sort">
        <DiscoveryContentSort
          sort={sort}
          onSort={onSort}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-interaction">
        {this.renderToggle()}
        {this.renderStats()}
        {this.renderSort()}
      </div>
    );
  }
}

export default DiscoveryContentInteraction;
